import { render, staticRenderFns } from "./ArchiveTickets.vue?vue&type=template&id=493db7c4"
import script from "./ArchiveTickets.vue?vue&type=script&lang=js"
export * from "./ArchiveTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports